export const API_URL = 'https://api.itsallaboutheoptions.com/api/admin'
export const SOCKET_URL = 'wss://api.itsallaboutheoptions.com'

// export const API_URL = 'https://allaboutheoptions.test/api/admin'
// export const SOCKET_URL = 'wss://allaboutheoptions.test/socket.io/'

export const FACEBOOK_APP_ID = "9558663540853784"
export const GOOGLE_CLIENT_ID = "115181365241-2ihempknf58hd5appbfsa1g5jlt4pr3t.apps.googleusercontent.com"

export const RECAPTCHA_SITE_KEY = "6LcQd20rAAAAAF5bJxhq6iau12Zj4YrBXJNKyD9U"
